export enum AccountModalPages {
    SignUp,
    Login,
    RecoverPassword,
    Account,
    SetNewPassword,
  }